export default __webpack_public_path__ + "static/identifying-drop-offs-dark-mode-014c7a3da2fbd8c959b0ff972f1dba59.png";